export enum VALIDATION_FIELDS {
    email = 'email',
    gender = 'gender',
    firstname = 'firstname',
    lastname = 'lastname',
    dateOfBirth = 'dateOfBirth',
    phone = 'phone',
    membershipNumber = 'membershipNumber',
    pin = 'pin',
    confirmPin = 'confirmPin',
    pinReg = 'pinReg',
    confirmPinReg = 'confirmPinReg',
    password = 'password',
    confirmPassword = 'confirmPassword',
    oldPassword = 'oldPassword',
    verificationQuestion = 'verificationQuestion',
    verificationAnswer = 'verificationAnswer',
    zip = 'zip',
    house = 'house',
    street = 'street',
    address = 'address',
    homeVenue = 'homeVenue',
    city = 'city',
    state = 'state',
    terms = 'terms',
    promoCode = 'promoCode',
    postcode = 'postcode',
    userName = 'userName',
    userNameRetail = 'userNameRetail',
    searchAddress = 'searchAddress',
    amount = 'amount',
    occupation = 'occupation',
    from = 'from',
    until = 'until'
}

export enum CUSTOM_VALIDATION_FIELDS {
    login = 'login.password',
    userdetails = 'userdetails.password',
    duplicate = 'duplicate.email',
    slotRegContactByEmail = 'slotReg.casino_contactByEmail',
    slotRegContactBySMS = 'slotReg.casino_contactBySMS'
}

export enum VALIDATION_EVENTS {
    SET_PIN_ERROR = 'SET_PIN_ERROR',
    SET_MEMBERSHIP_ERROR = 'SET_MEMBERSHIP_ERROR'
}
